module.exports = __webpack_public_path__ + "media/images/iconLockClosed__inactive--dark-ad7e66e574bd924453138e19262d6bdc.png";